import { AccessControl } from "@careinfo/permission-required";
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import APIS from "../../constant/EndPoint";
import TrashIcon from "../../Icons/TrashIcon";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Modal from "../Reusable/Modal";
import TableActionButton from "../Reusable/TableActionButton";
import Button from "../Reusable/Button";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import usePermission from "../../customHooks/usePermission";

const RoleList = (props: any) => {
  const { setError } = useForm({});
  const { handleDelete, isLoading } = props;
  const [openDeletePopup, setOpenDeletePopup] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const navigate = useNavigate();
  const canUpdateGroup = usePermission({
    allowedPermissions: ["can_update_group"],
  });
  const handleRowClick = (row: any) => {
    if (!canUpdateGroup) return;
    navigate(`edit/${row?.original?.id}`);
  };
  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "group_name",
      cell: NACell,
    },
    {
      header: "Allow Permission",
      accessorKey: "custom_permissions",
      cell: ({ row, getValue }: any) => (
        <>{getValue() ? getValue()?.length : 0}</>
      ),
    },
    {
      header: "Assign Member",
      accessorKey: "assigned_members",
      cell: ({ row, getValue }: any) => <>{getValue() ? getValue() : 0}</>,
    },
    {
      header: "Action",
      accessorKey: "pk",
      cell: ({ row, getValue }: any) => (
        <div className={tw`grid grid-cols-2 items-center `}>
          <AccessControl
            children={
              <button
                type="button"
                disabled={isLoading || false}
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedRole(row?.original.id);
                  setOpenDeletePopup(!openDeletePopup);
                }}
                className="focus:outline-none"
              >
                <TrashIcon color={"var(--primary)"} />
              </button>
            }
            allowedPermissions={["can_delete_group"]}
          />
        </div>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.GROUP}
        queryKey={"roles"}
        columns={defaultColumns}
        addNewPagePath={"/create"}
        tableName={"Role"}
        onRowClick={handleRowClick}
      />
      <Modal isOpen={openDeletePopup} setIsOpen={setOpenDeletePopup} title={""}>
        <div className={tw`flex flex-col justify-center items-center  h-fit`}>
          <p className={tw`text-lg font-semibold mb-4`}>
            Are you sure you want to delete ?
          </p>
          <div className={tw`mt-6 flex gap-x-6 items-center`}>
            <div className={tw`w-24`}>
              <Button
                label={"Yes"}
                isLoading={isLoading}
                onClick={() =>
                  handleDelete(selectedRole, setOpenDeletePopup, setError)
                }
              />
            </div>
            <div>
              <button
                type="button"
                className={tw`w-full px-[24px] py-2 rounded  focus:outline-none bg-[#EEF5F4]`}
                onClick={() => setOpenDeletePopup(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RoleList;
